import { combineReducers } from 'redux';

import checklists from './checklists';
import items from './items';

const stack = combineReducers({
  checklists,
  items,
});

export type ChecklistUiStackReducer = ReturnType<typeof stack>;

export default stack;
